import React from 'react';
import { createRoot } from 'react-dom/client';

import PageContainer from './containers/PageContainer';
import { rootNode } from './configs';

const TopPublishers = () => <PageContainer />;

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<TopPublishers />);
});
